import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=a99a0c46"
import script from "./AllCompanies.vue?vue&type=script&lang=js"
export * from "./AllCompanies.vue?vue&type=script&lang=js"
import style0 from "./AllCompanies.vue?vue&type=style&index=0&id=a99a0c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports